export default __webpack_public_path__ + "static/index-title-versions-zh-Hans-5133fa1b57bec1389b85e68d14ff32e8.png";